var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Star } from '@hn-ui/icons';
import { BlueIconButton } from '@hn-ui/buttons';
import { ratePositions } from './models';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1p3645z" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  border-top: 1px solid ", ";\n  padding-top: 16px;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  border-top: 1px solid ", ";\n  padding-top: 16px;\n  gap: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black95;
});
var Title = styled.h5.withConfig({ displayName: "Title", componentId: "sc-gcsjua" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: Noto Sans, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  margin: 0;\n"], ["\n  font-family: Noto Sans, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  margin: 0;\n"])));
var StarItems = styled.ul.withConfig({ displayName: "StarItems", componentId: "sc-1lvevqz" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n"], ["\n  display: flex;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n"])));
var StarItem = styled.li.withConfig({ displayName: "StarItem", componentId: "sc-qx1x1q" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n\n  &&&[aria-selected='true'] svg {\n    fill: ", ";\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n\n  &&&[aria-selected='true'] svg {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.yellow80;
});
var IconButton = styled(BlueIconButton).withConfig({ displayName: "IconButton", componentId: "sc-kzend5" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      & > svg {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      & > svg {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black90;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.black90;
});
var handleOnMouseEnter = function (event) {
    var starElement = event.target;
    var starList = starElement.closest('ul');
    if (!starList)
        return;
    var position = +(starElement.ariaValueNow || 0);
    for (var index = 0; index < starList.children.length; index++) {
        var child = starList.children.item(index);
        if (child) {
            if (index < position)
                child.ariaSelected = 'true';
            else
                child.ariaSelected = 'false';
        }
    }
};
var handleOnMouseLeave = function (event) {
    var starElement = event.target;
    var starList = starElement.closest('ul');
    if (!starList)
        return;
    for (var index = 0; index < starList.children.length; index++) {
        var child = starList.children.item(index);
        if (child) {
            child.ariaSelected = 'false';
        }
    }
};
var RateSection = function (_a) {
    var onRate = _a.onRate, selectedPosition = _a.selectedPosition, readonly = _a.readonly, rest = __rest(_a, ["onRate", "selectedPosition", "readonly"]);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Title, { children: "Rate this printable" }, void 0), _jsx(StarItems, { children: ratePositions.map(function (position) { return (_jsx(StarItem, { children: _jsx(IconButton, __assign({ onClick: function () {
                            if (!readonly)
                                onRate(position);
                        } }, { children: _jsx(Star, { "aria-valuenow": position, onMouseLeave: readonly ? undefined : handleOnMouseLeave, onMouseEnter: readonly ? undefined : handleOnMouseEnter }, void 0) }), void 0) }, position)); }) }, void 0)] }), void 0));
};
export { RateSection };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
